export const domain = "https://interfaces.dev";
export const discordPath = "/magazine/discord";
export const supportEmail = "jakub@kbo.sk";
export const siteName = "Interfaces › Design Engineering Magazine";
export const siteDescription =
  "Interfaces is a design engineering magazine about building great interfaces that covers topics such as animation, typography, layout and color.";
export const ogImageUrl =
  "https://ho1jr3x2dcwdu3t5.public.blob.vercel-storage.com/og-image.png";
export const twitterHandle = "@jakubkrehel";
export const skillsRegistryUrl = "https://skills.sh/jakubkrehel/skills";
export const skillsRepoUrl = "https://github.com/jakubkrehel/skills";
export const NEWSLETTER_SUBSCRIBER_COUNT = 2624;
